import { Route } from "react-router-dom";
import { _adr } from "../address";
import { Roles } from "../tools/services";
import { ProtectedRoute } from "../tools/protectedRoute";
import DCBulk from "../components/bulks/dc/DCBulk";

export const bulkRoutes = [
	<Route
		key="bulk-dc"
		path={_adr.Root + _adr.Bulks.Index + _adr.Bulks.DCBulk}
		element={<ProtectedRoute role={Roles.Dealer_GroupActivation_Charge_API} element={DCBulk} />}
	/>,
];
